"use strict";
var _a;
const updateNoteSelectors = {
    cartForm: '#cart',
    cartNote: '#cartSpecialInstructions',
};
function debounce(func, timeout = 500) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(null, args); }, timeout);
    };
}
function updateCartNote(e) {
    const cartNote = document.querySelector(updateNoteSelectors.cartNote);
    if (cartNote && e.target.closest(updateNoteSelectors.cartNote)) {
        const cartForm = document.querySelector(updateNoteSelectors.cartForm);
        fetch('/cart/update.js', {
            method: 'POST',
            body: new FormData(cartForm),
        })
            .then((response) => response.json())
            .catch((error) => {
            console.error('Error:', error);
        });
    }
}
(_a = document.querySelector(updateNoteSelectors.cartNote)) === null || _a === void 0 ? void 0 : _a.addEventListener('keyup', debounce((e) => updateCartNote(e), 1000));
